import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Shield } from 'lucide-react';
import { useLocale } from '../i18n/LocaleProvider';

const LOGO = "https://customer-assets.emergentagent.com/job_safe-studio/artifacts/mwjfvsq2_1000108957-Photoroom.png";

const Footer = () => {
  const { t } = useLocale();

  const platformLinks = [
    { to: '/', key: 'home' },
    { to: '/features', key: 'features' },
    { to: '/ecosystem', key: 'ecosystem' },
    { to: '/clubs-challenges', key: 'clubs' },
    { to: '/academy', key: 'academy' },
    { to: '/romind-lab', key: 'lab' },
    { to: '/venture-studio', key: 'ventureStudio' },
    { to: '/child-safety', key: 'safety' },
    { to: '/safety-research', key: 'safetyResearch' },
    { to: '/parents', key: 'parentSafety' },
    { to: '/blog', key: 'insights' },
    { to: '/testing', key: 'joinTesting' },
    { to: '/about', key: 'about' },
    { to: '/contact', key: 'contact' },
  ];

  const legalLinks = [
    { to: '/privacy', key: 'privacy' },
    { to: '/terms', key: 'terms' },
    { to: '/user-content-copyright', key: 'copyright' },
    { to: '/community-guidelines', key: 'community' },
    { to: '/child-safety-policy', key: 'childSafetyModeration' },
    { to: '/report-handling', key: 'reportHandling' },
    { to: '/data-retention', key: 'dataRetention' },
    { to: '/delete-account', key: 'deleteAccount' },
    { to: '/child-safety', key: 'childSafetyOverview' },
    { to: '/safety-research', key: 'childSafetyResearch' },
  ];

  return (
    <footer data-testid="footer" className="bg-[#030309] border-t border-white/5 pt-16 pb-10 px-4">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2.5 mb-4">
              <img src={LOGO} alt="ROMIND KIDS" className="h-9 w-9 object-contain" />
              <span className="font-outfit text-[15px] font-bold text-white">ROMIND <span className="text-purple-400">KIDS</span></span>
            </div>
            <p className="text-white/40 text-sm leading-relaxed max-w-xs mb-4">{t('footer.tagline')}</p>
            <a href="mailto:contact@romindkids.tech" data-testid="footer-email" className="flex items-center gap-2 text-sm text-white/40 hover:text-cyan-400 transition-colors w-fit">
              <Mail size={13} />
              contact@romindkids.tech
            </a>
          </div>

          <div>
            <h4 className="font-outfit font-semibold text-white/50 text-xs uppercase tracking-widest mb-4">{t('footer.platform')}</h4>
            <div className="flex flex-col gap-3">
              {platformLinks.map(({ to, key }) => (
                <Link key={to} to={to} className="text-sm text-white/40 hover:text-white transition-colors w-fit">{t(`footer.${key}`)}</Link>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-outfit font-semibold text-white/50 text-xs uppercase tracking-widest mb-4">{t('footer.legal')}</h4>
            <div className="flex flex-col gap-3">
              {legalLinks.map(({ to, key }) => (
                <Link key={to} to={to} className="text-sm text-white/40 hover:text-white transition-colors w-fit">{t(`footer.${key}`)}</Link>
              ))}
            </div>
          </div>
        </div>

        <div className="border-t border-white/5 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-white/25 text-xs">{t('footer.rights')}</p>
          <div className="flex items-center gap-2 text-white/25 text-xs">
            <Shield size={11} />
            <span>{t('footer.safetyPrinciples')}</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
